import { useProductOfferStore } from "@/sales-tools";

export const useMdnLookupResult = (sessionId: string) => {
    const eligibilityMeta = useProductOfferStore((state) => state.getEligibilityMetaBySessionId(sessionId));

    try {
        return eligibilityMeta.mdnLookupResult;
    } catch (error) {
        console.warn("Failed to read mdnLookupResult", { error });
        return {
            hasReachedMaxMdnLookups: false,
            previousHashedMdnLookups: [],
        };
    }
};
